import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { t } from 'utils/translates';
import {
  selectCommentsInCountStat,
  selectCommentsOutCountStat,
  selectAvatarPath,
  selectRating
} from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/prefer-stateless-function
class RightSidebarFromAuthUser extends Component {
  render() {
    const ratingDesc = `${t('Рейтинг')}: ${
      this.props.rating.ratingStatusPoints
    }/${this.props.rating.ratingStatusPointsTo} (${
      this.props.rating.ratingStatusTitle
    })`;
    return (
      <div className="page-sidebar-sticky">
        <div className="page-sidebar-sticky-wrp">
          <div
            className="panel-group panel-group-side"
            id="panelGroupFilter"
            role="tablist"
            aria-multiselectable="true"
          >
            <div className="panel panel-default border-b text-center">
              <div className="panel-body">
                <img
                  alt=""
                  className="avatar avatar-responsive avatar_bordered"
                  src={this.props.avatarPath}
                />
                <div
                  className="label label-light label-success label_block text-overflow m-t-10"
                  data-toggle="tooltip"
                  data-container="body"
                  data-placement="top"
                  title={ratingDesc}
                >
                  <i
                    className={
                      this.props.rating.rating >= 20
                        ? 'fa fa-star'
                        : 'fa fa-star-o'
                    }
                  />
                  <i
                    className={
                      this.props.rating.rating >= 40
                        ? 'fa fa-star'
                        : 'fa fa-star-o'
                    }
                  />
                  <i
                    className={
                      this.props.rating.rating >= 60
                        ? 'fa fa-star'
                        : 'fa fa-star-o'
                    }
                  />
                  <i
                    className={
                      this.props.rating.rating >= 80
                        ? 'fa fa-star'
                        : 'fa fa-star-o'
                    }
                  />
                  <i
                    className={
                      this.props.rating.rating >= 100
                        ? 'fa fa-star'
                        : 'fa fa-star-o'
                    }
                  />{' '}
                  {this.props.rating.ratingStatusTitle}
                </div>
                <NavLink
                  to="/main/update-account"
                  className="btn btn-muted btn-block btn-sm m-t-10"
                >
                  {t('Редактировать')}
                </NavLink>
              </div>
            </div>
            <NavLink
              to="/main/my-page/comments"
              activeClassName="active"
              className="list-group-item"
            >
              <span className="badge">
                {this.props.commentsInCountStat.total}
              </span>
              <span className="list-group-item-val text-overflow">
                {t('Отзывы о пользователе')}
              </span>
            </NavLink>
            <NavLink
              to="/main/my-page/comments-from-user"
              activeClassName="active"
              className="list-group-item"
            >
              <span className="badge">
                {this.props.commentsOutCountStat.total}
              </span>
              <span className="list-group-item-val text-overflow">
                {t('Оценки, комментарии')}
              </span>
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
}

RightSidebarFromAuthUser.propTypes = {
  avatarPath: PropTypes.string.isRequired,
  rating: PropTypes.shape({
    rating: PropTypes.string.isRequired,
    ratingStatusTitle: PropTypes.string.isRequired,
    ratingStatusPoints: PropTypes.number.isRequired,
    ratingStatusPointsTo: PropTypes.number.isRequired
  }).isRequired,
  commentsInCountStat: PropTypes.shape({
    dislikes: PropTypes.number.isRequired,
    likes: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired,
  commentsOutCountStat: PropTypes.shape({
    dislikes: PropTypes.number.isRequired,
    likes: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  avatarPath: selectAvatarPath(state),
  rating: selectRating(state),
  commentsInCountStat: selectCommentsInCountStat(state),
  commentsOutCountStat: selectCommentsOutCountStat(state)
});

export default withRouter(connect(mapStateToProps)(RightSidebarFromAuthUser));



// WEBPACK FOOTER //
// ./src/components/UserAccount/RightSidebarFromAuthUser/RightSidebarFromAuthUser.js